/** Column header of the desktop check-inventory table (`./CheckInventoryModalTableConfig.tsx`). */
import React from "react";
import { CheckInventoryContent, CheckInventoryLabels } from "../CheckInventoryModalContent";
import { useTheme } from "@ryerson/frontend.theme";
import { Flex } from "@ryerson/frontend.layout";
import { Typography } from "@ryerson/frontend.typography";
import { useApplication } from "@ryerson/frontend.application";

/**
 * Pass `contentKey` for a translated label, or `headerTitle` for text already built. Both render
 * when both are set.
 */
interface CheckInventoryModalTableColumnHeaderProps {
	contentKey?: keyof CheckInventoryLabels;
	headerTitle?: string;
}
/** Centered bold header label in the current language. */
const CheckInventoryModalTableColumnHeader: React.FC<CheckInventoryModalTableColumnHeaderProps> = ({
	contentKey,
	headerTitle,
}) => {
	const { theme } = useTheme();
	const { header } = theme.colors.primary;

	const {
		localization: { language },
	} = useApplication();
	const content = CheckInventoryContent[language];

	return (
		<Flex justifyContent={"center"}>
			<Typography color={header} weight="bold" size={"sm"}>
				{contentKey && content[contentKey]}
				{headerTitle}
			</Typography>
		</Flex>
	);
};

export default CheckInventoryModalTableColumnHeader;
